angular
.module('inputContract.components', [])
.component('inputContract', {
	templateUrl: 'ng/components/inputContract/inputContract.html',
	bindings: {
		/** Input data **/
		inputId: '@',
		inputName: '@',
		inputClass: '@',
		inputPlaceholder: '@',
		formName: '=',
		bindingVariable: '=',
		/** Optional data **/
		inputDisableOn: '<'
	},
	controllerAs: 'inputContractCtrl',
	controller: function($scope, $translate, validationService) {

		/** not to loose *this reference **/
		var self = this;

		self.validationService = validationService; 

        self.$onInit = function () {
        	console.log(self);
        	self.inputDisableOn = self.inputDisableOn || false;

        }

        self.$onChanges = function(){

        }

      self.errorMsgShown = false;
      self.validationService = validationService;

      self.resetAlert = function(){
        self.errorMsgShown = false;
      }

      self.showAlertMsg = function(){
        self.errorMsgShown = !self.errorMsgShown;
      }

	}
});
